import styled from 'styled-components'

import { PAGE_LAYOUT_OFFSET } from '../constants/layout'

export const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: calc(100vh - ${PAGE_LAYOUT_OFFSET}px);
  max-height: calc(100vh - ${PAGE_LAYOUT_OFFSET}px);
  overflow-y: auto;
  padding: 2em 1em 3em;
  box-sizing: border-box;
`

export const Panel = styled.div`
  width: 100%;
  max-width: 520px;
  display: flex;
  flex-direction: column;
  gap: 1em;
  padding: 1.5em;
  background-color: #070707;
  border: 1px solid #414244;
  border-radius: 0.5em;
  box-sizing: border-box;
`

export const Title = styled.h3`
  margin: 0;
  color: #88ba44;
  font-size: 1.3em;
  text-align: center;
  font-family: 'Chivo', sans-serif;
  font-weight: bold;
`

export const Text = styled.p`
  margin: 0;
  color: #c5c5c5;
  font-size: 1em;
  text-align: center;
  line-height: 1.4;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1em;
  width: 100%;
`

export const ErrorText = styled.p`
  margin: 0;
  color: #ff6b6b;
  text-align: center;
  font-size: 0.95em;
`

export const SuccessText = styled.p`
  margin: 0;
  color: #78bc28;
  text-align: center;
  font-size: 0.95em;
  line-height: 1.5;
`

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0.25em;
`
